function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLereste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68.2 43.9",
    style: {
      enableBackground: "new 0 0 68.2 43.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M23.1,21.7v-7.5c0-1-0.2-2-0.7-2.8s-1-1.7-1.7-2.3c-0.7-0.7-1.5-1.2-2.5-1.7c-1-0.5-1.9-0.5-2.9-0.5h-2.5 c-0.7,0-1.3-0.2-1.9-0.5C10.3,6,9.6,5.7,9.1,5.2C8.6,4.7,8.2,4,7.9,3.2C7.6,2.5,7.2,1.7,7.2,0.9h8.1c1.9,0,3.5,0.3,5.2,1 c1.7,0.7,3.2,1.7,4.4,2.8c1.3,1.3,2.4,2.7,3,4.3c0.7,1.7,1.2,3.3,1.2,5.2v13.2H14.6c-1,0-2,0.3-2.9,0.8s-1.7,1.2-2.5,1.8 c-0.8,0.7-1.3,1.3-1.9,2.2c-0.3,0.8-0.7,1.8-0.7,3v2.5c0,0.8-0.2,1.5-0.3,2.2c-0.2,0.7-0.7,1.3-1.2,1.8c-0.3,0.5-1,0.8-1.7,1.2 s-1.7,0.5-2.7,0.5v-8c0-2.2,0.3-4,1-5.5c0.7-1.7,1.5-3,2.9-4.3c2.9-2.5,6.1-3.8,9.9-3.8H23.1z M13.3,36.9c0-1.2,0.3-2.2,1.2-2.8 c0.8-0.8,1.7-1.3,2.9-1.3c1,0,2,0.3,2.7,1.2c0.7,0.8,1.2,1.8,1.2,2.8s-0.3,2-1.2,2.7c-0.7,0.7-1.7,1.2-2.7,1.2 c-1.2,0-2-0.3-2.9-1.2C13.8,38.9,13.3,37.9,13.3,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M46,6.4c-0.8,0-1.5,0-2.2-0.2c-0.8-0.2-1.5-0.7-2.4-1.3c-0.3-0.3-0.7-1-0.8-1.5c-0.2-0.5-0.3-1.5-0.5-2.8 h13.5c1.9,0,3.7,0.3,5.4,1c1.7,0.7,3.2,1.7,4.4,2.8c1.3,1.3,2.4,2.8,3,4.3s1,3.3,1,5.3c0,1.8-0.3,3.7-1,5.3c-0.7,1.7-1.7,3.2-3,4.5 c-1.2,1.3-2.7,2.2-4.2,2.7s-3.4,0.8-5.4,0.8H36c0.3-2,1-3.5,1.9-4.3c1.2-1,2.5-1.5,4-1.5h11.6c1,0,1.9-0.2,2.7-0.7 c0.8-0.3,1.7-1,2.5-1.7c0.8-0.8,1.5-1.7,1.9-2.5c0.3-0.8,0.7-1.7,0.7-2.8c0-1-0.2-2-0.5-2.8c-0.3-0.8-1-1.5-1.9-2.3 C58.1,8,57.2,7.4,56.2,7c-1-0.3-1.9-0.7-2.9-0.7h-7.2L46,6.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLereste);
export default __webpack_public_path__ + "static/media/le reste.b2e3c8c796a517cadce5164355a7bf4b.svg";
export { ForwardRef as ReactComponent };